import React, { useEffect, useState } from "react";

// Animated radial gauge for the 0-1000 Contractor Readiness Score
export default function ReadinessGauge({ score = 0, tier = "", size = 200 }) {
  const [display, setDisplay] = useState(0);
  const max = 1000;

  useEffect(() => {
    let raf;
    const start = performance.now();
    const duration = 1100;
    const animate = (t) => {
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * score));
      if (p < 1) raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [score]);

  const color = score >= 800 ? "#059669" : score >= 500 ? "#F59E0B" : "#DC2626";
  const radius = size / 2 - 16;
  const circ = Math.PI * radius; // semicircle
  const pct = Math.min(display / max, 1);
  const offset = circ - pct * circ;

  return (
    <div className="flex flex-col items-center justify-center" style={{ width: size }} data-testid="readiness-gauge">
      <svg width={size} height={size / 2 + 24} viewBox={`0 0 ${size} ${size / 2 + 24}`}>
        <path
          d={`M 16 ${size / 2} A ${radius} ${radius} 0 0 1 ${size - 16} ${size / 2}`}
          fill="none"
          stroke="#E2E8F0"
          strokeWidth="14"
          strokeLinecap="round"
        />
        <path
          d={`M 16 ${size / 2} A ${radius} ${radius} 0 0 1 ${size - 16} ${size / 2}`}
          fill="none"
          stroke={color}
          strokeWidth="14"
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.1s linear" }}
        />
      </svg>
      <div className="-mt-[55px] flex flex-col items-center">
        <span className="font-data text-5xl font-semibold tracking-tight text-slate-900" data-testid="readiness-score-value">
          {display}
        </span>
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">/ 1000</span>
        <span
          className="mt-2 px-3 py-1 rounded-full text-xs font-semibold"
          style={{ backgroundColor: color + "1A", color }}
          data-testid="readiness-tier"
        >
          {tier}
        </span>
      </div>
    </div>
  );
}
